export default (state = '', { type, payload }) => {
    switch (type) {
        case 'USER_ACTIVE_PLAN':
            return payload
        case 'LOGOUT':
            return null
        default:
            return state
    }
}